import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/roles/why-proxify/dev_with_phone_mobile.png")